export default {
  title: '简历锁定配置管理',
  menu: '简历锁定配置管理',
  label: {
    status: '简历状态',
    lockTime: '锁定类型及时长',
    remindConfig: '提醒频率',
    hasConfig: {
      has: '已配置',
      not: '未配置'
    }
  },
  placeholder: {
    lockTime: '请输入锁定天数',
    remindConfig: '请配置'
  },
  btn: {
    deleteConfig: '删除',
    saveConfig: '保存',
    addConfig: '添加'
  },
  message: {
    deleteSuccess: '删除成功',
    cannotSaveEmpty: '请至少配置一条锁定规则',
    lockTypeIsRequired: '锁定类型不能为空',
    remindDaysLessThanLockDays: '锁定天数不能小于提醒频率天数总和',
    remindConfigIsNotInt: '提醒频率应该为整数',
    lockTimeIsNotInt: '锁定天数应该为大于一的整数',
    invalidRemindConfig: '提醒频率配置有误，只能包含数字和“+”',
    checkConfigList: '配置内容有误，请检查',
    remindConfigRuleTip: '固定锁定时间为5天时，需要在第二天、第四天以及第五天提醒的话，需要配置为：2+2+1\n久锁定时，需要每5天提醒一次，则配置为：5',
    confirmDelete: '确定删除该配置吗？'
  },
  lockType: {
    RELEASE: '释放',
    DAY_LOCK: '锁定',
    INFINITY_LOCK: '永久锁定'
  }
}
